export default __webpack_public_path__ + "static/property-decription-map-d-ae0b542eec8ed2c3a0d6c22870770eee.jpg";